const DB_NAME = 'findify-sala6-offline';
const STORE_NAME = 'snapshots';
const SNAPSHOT_KEY = 'workspace';
export const OFFLINE_CACHE_NAME = 'findify-sala6-offline-v1';

const openDatabase = (): Promise<IDBDatabase> => new Promise((resolve, reject) => {
  const request = indexedDB.open(DB_NAME, 1);
  request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME);
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

export const readOfflineSnapshot = async (): Promise<any | undefined> => {
  if (typeof indexedDB === 'undefined') return undefined;
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readonly');
    const request = transaction.objectStore(STORE_NAME).get(SNAPSHOT_KEY);
    request.onsuccess = () => {
      transaction.oncomplete = () => { db.close(); resolve(request.result); };
    };
    request.onerror = () => { db.close(); reject(request.error); };
    transaction.onerror = () => { db.close(); reject(transaction.error); };
    transaction.onabort = () => { db.close(); reject(transaction.error ?? new Error('Leitura offline interrompida.')); };
  });
};

export const writeOfflineSnapshot = async (value: any) => {
  if (typeof indexedDB === 'undefined') throw new Error('IndexedDB indisponível neste navegador.');
  const db = await openDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    transaction.objectStore(STORE_NAME).put(value, SNAPSHOT_KEY);
    transaction.oncomplete = () => { db.close(); resolve(); };
    transaction.onerror = () => { db.close(); reject(transaction.error); };
    transaction.onabort = () => { db.close(); reject(transaction.error ?? new Error('Gravação offline interrompida.')); };
  });
};
